<template>
    <div v-if="multiSectionList && multiSectionList.length"  class="multi-section-wrap">
      <div v-for="(sectionInfo) in multiSectionList" :key="sectionInfo.title" class="multi-section-container">
        <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo" />
      </div>

      <!-- ppv 문구 영역 -->
      <div class="ppv-notice">
        <p>Wavvie 영화관은 PLAYY가 제공하는 영화를 포함하고 있습니다.</p>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { onDisplay } from '@/common/directives'
import { enableBodyScroll } from '@/common/util/ui.utils'
import utils from '@/common/util/utils'
import { PATH_NAME_WAVVIE_POPUP } from '@/common/router.const'
export default {
  name: 'Movie',
  components: { DynamicSectionLoader },
  directives: {
    onDisplay
  },
  data () {
    return {
      isWavviePopupShow: true
    }
  },
  computed: {
    ...mapGetters(['multiSectionList', 'isWavviePopup'])
  },
  methods: {
    ...mapMutations({ showWavviePopup: 'showWavviePopup' })
  },
  created () {
    if (utils.cookies.getItem('wavvie-popup') !== '1') {
      this.$router.replace({ name: PATH_NAME_WAVVIE_POPUP })
    }
    enableBodyScroll()
  }
}
</script>
